import { AppLayout, ContentLayout, Container } from "@cloudscape-design/components";
import React from "react";
import { LegacyBoard } from "./legacyBoard";
import { LegacySlider } from "./legacySlider";
import { LegacyHeader } from "./legacyHeader";

// The public facing site. Unchanged skyscraper dashboard, served to everyone
// who does not have the preview token. See src/previewFlag.ts.
export const LegacySkyscraperPage = () => {
  const [isToolsOpen, setIsToolsOpen] = React.useState(true);
  return (
    <AppLayout
      headerVariant="high-contrast"
      navigationHide={true}
      toolsHide={false}
      toolsOpen={isToolsOpen}
      onToolsChange={({ detail }) => setIsToolsOpen(detail.open)}
      tools={<LegacySlider />}
      maxContentWidth={Number.MAX_VALUE}
      content={
        <ContentLayout
          defaultPadding
          headerVariant="high-contrast"
          header={<LegacyHeader openHelpPanel={setIsToolsOpen} />}
        >
          <Container>
            <LegacyBoard />
          </Container>
        </ContentLayout>
      }
    />
  );
};
